<template>
  <v-autocomplete
    id="filter-for-subject"
    ref="autocomplete"
    v-model="model"
    :items="items"
    :loading="false"
    :label="$t('page.list.filters.examSubject.label')"
    outlined
    dense
    hide-details="auto"
    :placeholder="$t('page.list.filters.examSubject.placeholder')"
    clearable
    @change="$emit('change')"
  />
</template>

<script>
const subjectFormats = ['digital', 'physical'];

function subject2item(subject) {
  return {
    text: `${subject.id}: ${subject.title}`,
    value: [subject.id]
  };
}

function compareSubjects(a, b) {
  return a.id - b.id;
}

function createCategoryHeader(name) {
  return { header: name };
}

function createCategoryItem(subjects, name) {
  return { text: name, value: subjects.map((subject) => subject.id) };
}

function createSubjectItems(subjects, formatNameFn, allNameFn, allSeriesNameFn) {
  return subjectFormats.flatMap((format) => {

    const allSubjectsOfFormat = subjects.filter((subject) => subject.format === format);
    if (!allSubjectsOfFormat.length) return [];

    const items = [
      createCategoryHeader(formatNameFn(format)),
      createCategoryItem(allSubjectsOfFormat, allNameFn(format))
    ];

    if (format === 'digital') {
      const subjects70s = allSubjectsOfFormat.filter((subject) => String(subject.id).startsWith('7'));

      if (subjects70s.length > 0) {
        items.push({
          text: allSeriesNameFn("70s"),
          value: subjects70s.map((subject) => subject.id)
        });
      }

      const subjects80s = allSubjectsOfFormat.filter((subject) => String(subject.id).startsWith('8'));

      if (subjects80s.length > 0) {
        items.push({
          text: allSeriesNameFn("80s"),
          value: subjects80s.map((subject) => subject.id)
        });
      }

    }

    items.push(...allSubjectsOfFormat.sort(compareSubjects).map(subject2item));

    return items;

  });
}

export default {

  inject: [
    'pruefungsfachverwaltung'
  ],

  props: {
    value: {
      default: () => [],
      type: Array
    }
  },

  data() {
    return {
      allSubjects: null
    };
  },

  computed: {
    // the model property implements v-model
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    items() {
      return this.allSubjects ? createSubjectItems(this.allSubjects, this.categoryHeader, this.selectAllString, this.selectAllSeriesString) : [];
    }
  },

  async created() {
    try {
      this.allSubjects = (await this.pruefungsfachverwaltung.getCourses()).data.examSubjects;
    } catch {
      this.allSubjects = null;
    }
  },

  methods: {
    focus() {
      this.$refs.autocomplete.$refs.input.focus();
    },

    categoryHeader(format) {
      return this.$t(`page.list.filters.examSubject.categoryHeader.${format}`);
    },

    selectAllString(format) {
      return this.$t(`page.list.filters.examSubject.selectAllString.${format}`);
    },

    selectAllSeriesString(format) {
      return this.$t(`page.list.filters.examSubject.selectAllDigitalSeriesString.${format}`);
    }
  }

};
</script>
